// Politique de mot de passe : 12 caractères minimum, 128 au plus, refus des mots de passe courants
// (petite liste embarquée) et des mots de passe dérivés de l'adresse de courriel. Pas de règle de composition.

export const LONGUEUR_MIN_MOT_DE_PASSE = 12;
export const LONGUEUR_MAX_MOT_DE_PASSE = 128;

/** Petite liste de mots de passe courants ou triviaux, comparée sans tenir compte de la casse. */
export const MOTS_DE_PASSE_COURANTS: readonly string[] = [
  '123456789012',
  '1234567890123',
  '12345678901234',
  '123456789123',
  '111111111111',
  '000000000000',
  '123123123123',
  '987654321098',
  'azertyuiopqs',
  'azertyuiop12',
  'azertyuiop123',
  'azertyuiop1234',
  'azerty123456',
  'azertyazerty',
  'qwertyuiop12',
  'qwertyuiop123',
  'qwerty123456',
  'qwertyqwerty',
  'motdepasse12',
  'motdepasse123',
  'motdepasse1234',
  'motdepasse2024',
  'motdepasse2025',
  'motdepasse2026',
  'mot de passe',
  'motdepassemotdepasse',
  'password1234',
  'password12345',
  'password123456',
  'passwordpassword',
  'password2024',
  'password2025',
  'password2026',
  'p@ssword1234',
  'p@ssw0rd1234',
  'iloveyou1234',
  'bienvenue123',
  'bienvenue1234',
  'bienvenue2026',
  'soleil123456',
  'libreville123',
  'libreville2026',
  'gabon1234567',
  'gabon2026gabon',
  'carburanttrack',
  'carburanttrack1',
  'carburanttrack123',
  'carburanttrack2026',
  'administrateur',
  'administrateur1',
  'administrateur123',
  'admin1234567',
  'adminadmin123',
  'changezmoi123',
  'changeme1234',
  'changeme12345',
  'abcdefghijkl',
  'abcdef123456',
  'abc123abc123',
  'aaaaaaaaaaaa',
  'football1234',
  'princesse123',
  'doudou123456',
  'chouchou1234',
  'jetaime12345',
  'nicolas12345',
  'superman1234',
  'trustno1trustno1',
  'letmein12345',
  'welcome12345',
  'monkey123456',
  'dragon123456',
  'sunshine1234',
  'master123456',
  'baseball1234',
  'starwars1234',
  'whatever1234',
  'qazwsxedcrfv',
  '1q2w3e4r5t6y',
  '1qaz2wsx3edc',
  'zaq12wsxcde3',
  'petrole12345',
  'carburant123',
  'carburant2026',
];

export interface ResultatPolitique {
  valide: boolean;
  motifs: string[];
}

export function verifierMotDePasse(motDePasse: string, contexte: { courriel?: string } = {}): ResultatPolitique {
  const motifs: string[] = [];
  const longueur = [...motDePasse].length;
  if (longueur < LONGUEUR_MIN_MOT_DE_PASSE) {
    motifs.push(`Le mot de passe doit comporter au moins ${LONGUEUR_MIN_MOT_DE_PASSE} caractères.`);
  }
  if (longueur > LONGUEUR_MAX_MOT_DE_PASSE) {
    motifs.push(`Le mot de passe ne doit pas dépasser ${LONGUEUR_MAX_MOT_DE_PASSE} caractères.`);
  }
  const minuscule = motDePasse.toLowerCase();
  if (MOTS_DE_PASSE_COURANTS.includes(minuscule) || MOTS_DE_PASSE_COURANTS.includes(minuscule.trim())) {
    motifs.push('Ce mot de passe figure dans la liste des mots de passe courants.');
  }
  if (longueur >= 1 && new Set([...motDePasse]).size === 1) {
    motifs.push('Le mot de passe ne doit pas répéter un seul caractère.');
  }
  if (contexte.courriel) {
    const local = contexte.courriel.toLowerCase().split('@')[0] ?? '';
    if (minuscule === contexte.courriel.toLowerCase() || (local.length >= 4 && minuscule.includes(local))) {
      motifs.push('Le mot de passe ne doit pas reprendre l’adresse de courriel.');
    }
  }
  return { valide: motifs.length === 0, motifs };
}
